import React, { useState, useEffect } from "react";
import {useTheme, withStyles} from "@mui/styles";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import AppAnimate from "../../components/AppAnimate";
import {connect, setStore} from "trim-redux";
import AppCard from "../../components/layout/components/AppCard";
import {Styles} from "../../../config/design/styles";
import RegisterNew from "./RegisterNew";
import {useTranslation} from "react-i18next";
import Logo from "../../components/elements/Logo";
import Title from "../../components/elements/Title";
import {Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {ChevronLeft} from 'lucide-react';
import {removeLocalStorages} from "../../../config/values";
const LoginWithToken = ({classes,user,isAuth}) => {

    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (isAuth) {
            if(!!user?.first_name){
                navigate('/')
            }

        }
    }, [user,isAuth ]);

    const handleLogout = () => {
        removeLocalStorages()
        setStore({
            isAuth: false,
            user: null,
        });
        navigate('/login')
    };
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('register')}>
            <div className={classes.authContentInner}>
                <AppCard
                    title={ <Logo old_logo parentStyle={{textAlign:"center",width:'100%'}} style={{width:150}}/>}
                >
                    <Grid container spacing={2} justifyContent={"center"}>
                        <Grid item size={{xs:11}} style={{marginTop:10,marginBottom:10,position:"relative"}}>

                            <Title color="field" align="left" style={{marginTop:10}}>{t("loginRegister")}</Title>
                            <Typography>{t("completeYourInfo")}</Typography>
                        </Grid>
                        <Grid item size={{xs:11}}>
                            <RegisterNew
                                user_id={user?.id}
                            />
                        </Grid>
                        <Grid item size={11}>
                            <Button
                                onClick={() => handleLogout()}
                                startIcon={<ChevronLeft className="lucide-icon"/>}
                                color="secondary"
                                size="small"
                            >
                                {t('back')}
                            </Button>
                        </Grid>
                    </Grid>
                </AppCard>
            </div>
        </AppAnimate>
    );
};
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(connect(mapStateToProps)(LoginWithToken));
